module.exports = __webpack_public_path__ + "static/media/about-page-hero.00489d9f.jpg";